module.exports = __webpack_public_path__ + "static/media/backCover.e16ee58c.png";